import BasicDatagrid from '../../../components/shared/tables/BasicDatagrid'
import { styled } from '@mui/material'
const HistoricoTable = styled(BasicDatagrid)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    height: '61vh'
  },
  [theme.breakpoints.up('lg')]: {
    height: '61vh'
  },
  [theme.breakpoints.up('xl')]: {
    height: '67vh'
  },

  '& .MuiDataGrid-row': {
    '& .MuiDataGrid-cell': {
      textAlign: 'center',
      justifyContent: 'normal',
      '&:nth-of-type(2)': {
        textAlign: 'left!important'
      },
      '&:nth-of-type(3)': {
        textAlign: 'left!important'
      },
      '&:nth-of-type(4)': {
        textAlign: 'left!important'
      },
      '&:nth-of-type(1)': {
        textAlign: 'center!important',
        backgroudColor: 'red',
        marginLeft: '0.3rem'
      },
      '&:nth-of-type(5)': {
        textAlign: 'left!important',
        backgroudColor: 'red',
        marginLeft: '0.3rem'
      }
    }
  },
  '& .MuiDataGrid-columnHeadersInner': {
    '&:nth-of-type(1)': {
      textAlign: 'center'
    }
  }
}))

export default HistoricoTable
